import React from 'react';
import SEO from '../components/SEO';
import '../styles/Home.css';

const Education = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToNavigation = () => {
    const element = document.getElementById('edu-navigation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const navigationItems = [
    { id: 'edu-what-is', title: 'What is Micropincher', icon: '?' },
    { id: 'edu-funding-rate', title: 'What is Funding Rate Strategy', icon: '%' },
    { id: 'edu-arbitrage', title: 'What is Arbitrage Technique', icon: '⇄' },
    { id: 'edu-profit', title: 'How to Calculate Profit', icon: '$' },
    { id: 'edu-how-use', title: 'How to Use Micropincher', icon: '▤' },
    { id: 'edu-not-a-bot', title: 'Why Micropincher is not a trading bot', icon: '✕' },
    { id: 'edu-notifications', title: 'Notifications about opportunities', icon: '🔔' },
    { id: 'edu-challenges', title: 'Two biggest challenges of funding fee strategy', icon: '⚡' },
    { id: 'edu-security', title: 'Is Micropincher a security risk for my accounts', icon: '🔒' },
    { id: 'edu-simulator', title: 'Why use the trading simulator', icon: '▷' },
    { id: 'edu-eu-limitations', title: 'EU limitations', icon: '⚖' },
  ];

  return (
    <div className="home-container">
      <SEO
        title="Education - Micropincher | Learn Crypto Arbitrage & Funding Rate Strategy"
        description="Learn everything about Micropincher, funding rate strategy, arbitrage technique, profit calculation and how to use the platform."
        keywords="crypto education, funding rate, arbitrage strategy, crypto trading, micropincher guide"
        canonicalUrl="https://micropincher.com/education"
      />
      <div className="home-content">
        <div className="home-header">
          <h1 className="home-title">Education Library</h1>
          <p className="home-subtitle">
            Everything you need to understand crypto arbitrage, funding rate strategies and how to use Micropincher effectively.
          </p>
        </div>

        <nav id="edu-navigation" className="edu-chapter-list">
          <ol>
            {navigationItems.map((item, index) => (
              <li key={item.id}>
                <button className="edu-chapter-link" onClick={() => scrollToSection(item.id)}>
                  {index + 1}. {item.title}
                </button>
              </li>
            ))}
          </ol>
        </nav>

        <div className="home-sections">

          <section id="edu-what-is" className="info-section">
            <h2>
              What is Micropincher
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              <b>Micropincher is</b> a crypto trading analysis and trading simulation platform designed for traders who want to trade with manageable risk. Currently there is publicly available funding rate strategy. Other strategies are only for our internal tradign and for closed community.
            </p>
            <p>
              <b>The platform offers </b> currently notifications with calculated profitable combinations of crypto assets to trade,
              gives you guideline to where, what and when to open positions (see disclaimer). It is not trading bot. Why
              it si not trading bot, is explained in other article (see other article). Micropincher downloads data from crypto exchanges, calculates
              combinations including trading fees. Calculation is every 3-5min. USer can configure notification channel how to receive the info about opportunities.
              Currently there is email channel and Telegram is coming soon. User can define minimal final profit to be notified about.
              User can also disable certain exchanges and/or symbols if doesn't want to use these.
            </p>
            <p>
              <b>Balance overview </b> across all exchanges is another practical feature. Funding fee strategy needs budget distributed across multiple exchanges which is not easy to manage especially if you work with hedging positions. Therefore
              we have implemented account balance overview, where you can see on one place where you have your budget, how much and what coins/tokens.
            </p>
            <p>
              <b>Orderbook</b> is one of two biggest challenges in the funding rate strategies and may be in crypto trading generally. Therefore we have invested to
              our platform, which streams orderbook for each coin which (even a little) brings a profit. We concentrate the data and use it for our indicators.
              We are also building other strategies (currently not yet public) on the realtime orderbook data.
            </p>
            <p>
               <b>Test your skills - </b> Trading funding rate strategy is relatively easy, but needs a practise and certain little skills. Micropincher contains trading simulation
               where you can open and close position, you can schedule jobs which will automatically open or close position based on certain conditions.
               There is also implemented hedging technique tools like hedge calculator and kind of bot, which automatically opens/closes hedging positions.
               This feature is currently available to closed community and its publishing will come soon.
            </p>
            <br/>
            <p>
              <b>Quick summary of what Micropincher features:</b>
            </p>
            <ul className="features-list">
              <li>Identifies arbitrage opportunities across multiple exchanges</li>
              <li>Displays funding rates, taker/maker fees, and other market data</li>
              <li>Displays account balances on integrated centralized exchanges</li>
              <li>Calculates real profit including taker/maker fees from tens of thousands combinations that can exist in each moment</li>
              <li>Sending notification before funding fee time via email (Telegram comes soon...)</li>
              <li>Calculation of recommended order size to avoid price slippage *)</li>
              <li>Simulates trades and calculates profit/loss - training tool to check your practise before you risk real money *)</li>
              <li>Semiautomatic opening and closure of individual positions *)</li>
              <li>Semiautomatic opening and closure of full hedging pair positions (or multi-positions)  *)</li>
              <li>Tracks opened and closed simulated positions with full profit history *)</li>
            </ul>
            <p className="note">
                *) - Available for closed community which help us to test the functionality. If you want to become part of
                test community, contact as directly. There is limited amount of members we can adopt, so we apologize
                if it is already full. But try it at least.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-funding-rate" className="info-section">
            <h2>
              What is Funding Rate Strategy
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              The <strong>funding rate strategy</strong> (also called funding fee arbitrage) is a market-neutral trading
              technique that profits from the periodic payments between long and short traders on perpetual futures contracts.
            </p>
            <p>
               <strong>Very shortly</strong>, you profit from having the position opened, not from change of the price. So if you catch
               right combination of exchange, symbol and time, your profit is 100% sure. That's why this strategy exists.
               The way how to be neutral to price move, which can happen during holding your position, is the hedging technique.
            </p>
            <p>
               <strong>Hedging technique means</strong> you open somwhere long position and somwhere short on the same symbol. Or you open short
               and spot position (which servers like a long). Simply, change of price of the symbol will generate profit on
               one position, and loss on the other position. But together is zero profit, and zero loss. So you collect only
               profit from the funding fee.
            </p>
            <p>
               <strong>The risk you will have to take</strong> and manage is closing of the hedge positions where (you will see) the prices are
               a little different all the time and the difference is changing. The change of the difference is your enemy. Also
               opening and closing positions needs taker maker fees for you must close hedge positions ideally with little profit to cover
               these costs. But they can be also covered from funding fee profit. So then only price difference change is the
               thing you need to manage.
            </p>
            <p>
               <strong>Therefore we created the simulation tool</strong> where you can simulate trading on multiple exchanges on one place. The simulator
               calculates profit from hedging positions, shows you actual price, best bod, best ask, orderbook situation (how much you
               can trade without price slippage and many other things including automation of opening and closing of the positions
               based on configured conditions. we strongly recommend to use simulator before you jump to real money. It is like
               you learn to drive a car. First you stressfully wath dashboard, concentrate on shift, clutch and other technicalities and
               you completely miss to watch road signs or you don't watch enough the street and situation around. After some hours of driving
               you get better practise, and you start to contrate on other things. And this is the same here. Manage Heading positions
               is like watching a birds and animals while driving 80mph on winding roads. So we offer you a chance to save money by training
               first your skills and techniques.
            </p>
            <p>
              <strong>How funding fee (rate) work:</strong> Perpetual futures contracts have no expiry date. Sometimes you can see "futures"
              and "perpetuals", then perpetual means, that you can close it whenever you want. The "futures" then means your contract has fixed
              closure date and time. In Micropincher we work purely with perpetuals. Exchanges want to have futures/perpetuals contract price the
              same like to asset below. But thanks to different interest of spot deals and for futures deals, and thanks to logic how exchange
              calculate the price, the prices can differ. In that moment exchange needs some holders of either short or long positions to
              close their position. And the way how to mitvate the users to close the unwanted positions si simple to take a part of their profit.
              Luckily, the stolen profit is credited to the holders of the oposite positions. And this is you, if you have in the right moment
              right position. This is the fundamental essence of the funding fee strategy.
            </p>
            <p>
              Then you need to understand why sometimes the funding rate is position number and sometimes negative. It is simple. The there is little
              technique how to remember what is what. Imagine you have long position and funding fee is position (e.g. +0.5%). Then this is "HOW MUCH LONG MUST PAY".
              If you remember this statement, then the other is just oposite. So at the end you will now, that if the number is positive, then you earn on short
              position (long must pay), and if negative, then you earn on long position (short must pay).
              <br/>
              +0.1% = short has profit (long is loosing) <br/>
              -0.1% = long has profit (short is loosing)

            </p>
            <p>
              <strong>Summary of the core idea:</strong> You profit from funding fee (mechanism of exchanges common for crypto exchanges), you dont profit or loos from price changes.
              This makes the trading more secure. You need to open hedging position to be price neutral. And your biggest
              risk, where you need some practis, is to close the hedging positions with zero profit and loss or with little profit,
              which is much easier than profit on standard trading.
            </p>
            <ul className="features-list">
              <li>Market neutral: price movement does not affect your net position</li>
              <li>Profit comes from recurring funding fee payments (every 8h typical, sometimes 1h)</li>
              <li>Risk is managed through simultaneous hedged positions</li>
              <li>Trick is the technique and skill to close hedging positions</li>
              <li>Limited in volume you can use without price slippage</li>
            </ul>
            <p className="note">
              Important: funding rates fluctuate. A opportunity that was profitable 30min ago may not be profitable now.
              Always verify current rates before entering a position. Page" Opportunities" for thos sitting by PC and notifications
              for those who are not sitting by PC or are duing something else, will help to see the actual situation.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-arbitrage" className="info-section">
            <h2>
              What is Arbitrage Technique
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              <strong>Arbitrage</strong> is the practice of exploiting price differences or market inefficiencies between two or more
              markets to generate profit with minimal or zero directional risk. In traditional finance, arbitrage opportunities
              are quickly eliminated as traders close the gap. In crypto, inefficiencies persist longer due to fragmented
              liquidity, slower capital flows, and exchange-specific mechanics.
            </p>
            <p>
              <strong>Types of arbitrage strategies:</strong>
            </p>
            <ul className="features-list">
              <li><strong>Funding Rate Arbitrage:</strong> Long on one exchange, short on another — collect the funding rate differential between them</li>
              <li><strong>Cross-exchange Spot/Futures Arbitrage:</strong> Buy spot on one exchange, sell futures on another to lock in a price spread *)</li>
              <li><strong>Contract Type Arbitrage:</strong> Exploit rate differences between perpetual and quarterly futures on the same exchange **)</li>
              <li><strong>Price difference across exchanges:</strong> Buy on one exchange and sell on other **)</li>
            </ul>
            <p>
              <strong>Key principle:</strong> In a true arbitrage, you hold opposing positions of equal size. The two legs hedge
              each other against price movement. Your profit is the spread — the difference in fees, rates, or prices between the two positions.
            </p>
            <p>
              <strong>Risks to consider:</strong> Arbitrage is not risk-free. Execution risk (prices move between opening two legs),
              liquidation risk (orderbook volume), and fee erosion (taker fees eating profit) must all be factored in before entering a position.
            </p>
            <p className="note">
              Micropincher helps you identify and simulate arbitrage opportunities, but the decision to execute always remains yours.<br/>
              *) Feature in development or testing at the moment.<br/>
              **) Feature not on the road map at the moment.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-profit" className="info-section">
            <h2>
              How to Calculate Profit
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              <strong>Calculating the real profit </strong> of a funding rate arbitrage trade requires accounting for all fees and payments involved.
              You need to consider that you open two positions. Each opening or closing step is payd. You pay either maker fee
              (if you place limit order), or taker fee (if you place market order). These fees are usually different and usually
              is the taker fee higher than maker fee.
            </p>
            <p>
              <strong>Micropincher calculates with the worst situation.</strong> So when counting the opening and closing fee, Micropincher takes
              the worse of those fees. If taker is bigger than maker fee, then Micropinchers counts with taker fee.
              You can then in reality use the cheaper position, depends on your decision and situation. So at the end you pay 4 times the fee. For
              opening each positions and closing. This is 4 times payment of either taker or maker fee.
            </p>
            <p>
              <strong>Next item </strong>needed to take into profit calculation <strong>is the funding fee</strong> it self. There are opportunities which count
              with fudning fee only from one position becuase the positions are opened on two different exchanges, which have funding time
              in different moment. And there are opportunities which count with fudning fee from both positions. In this case is usually
              one funding profit for you and the other is loss. Micropincher calculates the over all result. So it is typical practis, that
              even you have one funding fee as loss, you are still profiting. The funding fee of profiting position is big enough to
              cover the all fees and funding fee loss of the other position.
            </p>
            <p>
              <strong>Last item</strong> coming to profit and loss calculation <strong>is the change in price difference</strong> which appear during the time when you
              have the positions opened. This is the risk you need to manage by good technique and practise. The trading simulation
              will help you to practise hedging technique and observe what the pricing changes are doing during the funding time. You will also
              get a practise in estimation of price changes in short time and you will see how big (or small) deal is the change in price difference.
              It is a nice tool which saves budget and nerves.
            </p>
            <p><strong>Gross income (what you receive):</strong></p>
            <ul className="features-list">
              <li>Funding fee received on the profiting position (either short or long - depends on funding rate) paid every 1-8h depends on exchange and symbol</li>
              <li>Change in the "price difference" between exchanges - price spread change where you profit (it is very rare - usually this goes against you)</li>
              <li>Profit from closing of hedge positions - close one, and close the other a bit later to earn from price move</li>
            </ul>
            <p><strong>Costs to subtract:</strong></p>
            <ul className="features-list">
              <li>Taker or maker fee for opening the long position (or spot)</li>
              <li>Taker or maker fee for opening the short position</li>
              <li>Taker or maker fee for closing the long position (or spot)</li>
              <li>Taker or maker fee for closing the short position</li>
              <li>Funding fee paid on the non profiting position paid every 1-8h depends on exchange and symbol</li>
              <li>Change in the "price difference" between exchanges - price spread change where you loose (it is very often - other direction of price move is very occasional)</li>
              <li>Slippage when opening and closing positions (happens when your order is too big for orderbook)</li>
            </ul>
            <p><strong>Simple profit formula:</strong></p>
            <p style={{ fontFamily: 'Courier New, monospace', background: '#0d1117', padding: '12px', borderRadius: '4px', border: '1px solid #30363d', fontSize: '13px' }}>
              Net Profit = (Funding Received × Number of Periods) − (Open Fees + Close Fees + Funding Paid) +(-) Price difference change
            </p>

            <p className="note">
              Micropincher's trade simulator does these calculations automatically — you can see the estimated profit, percentage for each opportunity and other numbers before deciding to simulate or enter.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-how-use" className="info-section">
            <h2>
              How to Use Micropincher
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>Follow these steps to get the most out of Micropincher:</p>
            <ul className="features-list numbered">
              <li><strong>Create an account</strong> — Sign up with Google account. Apple account coming soon. Your email
                is only used for account-related communications. Be aware of Privacy and Terms & Conditions, read them first.</li>
              <li><strong>Connect your exchanges (optional)</strong> — Go to Settings and add read-only API keys for the exchanges
                you trade on. This enables balance visibility. Micropincher cannot place orders or withdraw funds. So there is no risk of account theft.</li>
              <li><strong>Check funding fees and taker maker fees</strong> - Brows through the page to see the fees, learn how to use filters.</li>
              <li><strong>Order a plan</strong> - to see Opportunities and receive notifications you need to buy a plan. Go to menu and follow the payment process.</li>
              <li><strong>Explore Opportunities</strong> — The Opportunities page lists all currently detected funding rate arbitrage
                opportunities across supported exchanges. You can filter by symbol, exchange, profit range, and strategy type.</li>
              <li><strong>Setup notifications</strong> - Go to Notifications -> Funding Rate Notifications, select the channel, follow
                instructions for that channel. You will start to receive the notifications with list of currently existing opportunities.</li>
              <li><strong>Simulate a trade</strong> — Currently community only - Click on an opportunity to see the detail. Use the "New Trade" button to simulate
                opening a position. The simulator tracks virtual entry/exit prices and funding payments.</li>
              <li><strong>Monitor your trades</strong>  — Currently community only — The Trades page shows all your simulated positions: open trades with real-time
                profit estimates and closed trades with final realized profit.</li>
              <li><strong>Use the data to trade</strong> — Opportunities show the relevant info you need to open the positions on the exchanges. You can consider
                replicating it manually. Automation of these steps is under develoement at the moment.</li>
            </ul>
            <p className="note">
              The Free plan gives you access to Funding Rates and Taker/Maker data. The Monthly and Annual plans unlock Opportunities and Notifications. Currently Trading simulations is enabled for community only.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-not-a-bot" className="info-section">
            <h2>
              Why Micropincher is not a trading bot
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              Traditional trading strategies — especially those based on price prediction or technical analysis — are
              self-defeating at scale: if enough participants adopt the same algorithm, the market inefficiency it
              exploits disappears.
            </p>
            <p>
              While Micropincher could technically be extended into a fully automated trading tool, deployment of such
              a system would be more appropriate for institutional users. This is due to two key reasons: the security
              requirements around granting automated access to live trading accounts, and the level of expertise needed
              to properly supervise a bot, monitor its behavior, and adjust its parameters as market conditions change.
            </p>
            <p>
              This is why we are not building a fully automated trading bot. Instead, Micropincher is being developed
              as a <strong>unified trading interface</strong> — a single platform for managing positions across multiple
              exchanges simultaneously, designed around funding rate arbitrage strategies. The approach is intentionally
              semi-automatic: the platform handles complexity and execution, while trading decisions remain in the hands
              of the user.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-notifications" className="info-section">
            <h2>
              Notifications about opportunities
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              Micropincher monitors funding rate opportunities continuously and alerts you before the funding time
              arrives — so you have time to prepare your positions rather than reacting at the last second.
            </p>
            <p>
              <strong>Notification channels:</strong> Currently two channels are supported. <strong>Email</strong> is
              fully available now. <strong>Telegram</strong> is under development and coming soon. You can configure
              your preferred channel in the Notifications settings page.
            </p>
            <p>
              <strong>Email destination:</strong> The email address you set as your notification destination is
              independent from the email address you used to register your account. You can direct alerts to any
              inbox you prefer — for example a dedicated trading mailbox or your phone's email app.
            </p>
            <p>
              <strong>Lead time:</strong> Notifications are sent a configurable number of minutes before the funding
              time. We recommend setting a lead time of <strong>20 to 30 minutes</strong>. Setting it too far in
              advance is counterproductive — market conditions can change significantly and the opportunity may no
              longer be valid by the time funding occurs. Setting it too short leaves you without enough time to
              move funds to the relevant exchange and open your positions.
            </p>
            <p>
              <strong>What is included in the notification:</strong> Each notification contains the list of currently
              detected opportunities filtered according to your personal configuration — minimum profit threshold,
              excluded exchanges, excluded symbols, and so on. Only opportunities that meet your criteria are shown.
            </p>
            <p>
              <strong>Multiple notifications per funding event:</strong> If market conditions change between the time
              a notification was sent and the actual funding time, Micropincher will send a follow-up notification
              with the updated list. This means you may receive several notifications for a single funding event.
              Each one reflects the most current state of the market at the moment it was sent.
            </p>
            <p className="note">
              Notifications require an active Monthly or Annual plan. Make sure your notification channel is
              configured in Settings before your first funding event — alerts will not be sent retroactively.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-challenges" className="info-section">
            <h2>
              Two biggest challenges of funding fee strategy
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              Collecting the funding fee itself is actually the easiest part of this strategy. The real difficulty
              lies in two operational challenges that require practice, good tooling, and careful execution.
            </p>
            <p>
              <strong>Challenge 1 — Opening and closing positions without price slippage.</strong> When your order
              size exceeds what the orderbook can absorb at the best price, each additional unit is filled at a
              progressively worse price. This is price slippage, and it can quietly eat into — or entirely eliminate
              — the profit you calculated before entering. The larger your position, the more significant this
              effect becomes.
            </p>
            <p>
              To address this, we are currently developing two tools. The first is an <strong>orderbook
              analyzer</strong> that evaluates the depth of the orderbook in real time and tells you the maximum
              order size you can place at once without causing meaningful slippage. The second is an{' '}
              <strong>iceberg order tool</strong>, which splits a large position into many smaller orders and
              manages their execution automatically — minimizing market impact when opening or closing positions.
            </p>
            <p>
              <strong>Challenge 2 — Closing a hedged pair of positions at zero or minimal loss.</strong> Because
              your two legs (long and short) are opened on different exchanges, the price spread between them
              changes constantly. Closing both legs at exactly the right moment — so that the spread change does
              not exceed your funding fee profit — requires timing, patience, and technique. Done poorly, a bad
              exit can wipe out everything you earned from the funding fee.
            </p>
            <p>
              To help with this, we are currently testing <strong>automated hedging logic</strong> that monitors
              your open positions, tracks the price spread between the two legs, and automatically manages the
              closure sequence to protect your profit margin.
            </p>
            <p>
              Both of these challenges require a degree of skill that comes with practice. If you are not yet
              confident in your technique, the <strong>trade simulator</strong> is the right place to start.
              We continuously improve the simulator to give you the closest possible experience to trading on a
              real exchange — without putting real money at risk.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-security" className="info-section">
            <h2>
              Is Micropincher a security risk for my accounts
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              The short answer is <strong>no</strong>. Micropincher is designed from the ground up as a read-only
              analysis and decision-support platform. It does not move assets, place orders, or interact with your
              exchange accounts in any way that could put your funds at risk.
            </p>
            <p>
              <strong>Publicly available data:</strong> The majority of data Micropincher works with — funding
              rates, market prices, exchange fees — is publicly available and requires no authentication to access.
              For exchanges that do require authentication to retrieve taker/maker fee or funding fee data, we use
              API keys belonging to our own internal default accounts. Your personal credentials are never involved
              in this process.
            </p>
            <p>
              <strong>Balance overview and your API keys:</strong> If you choose to use the balance overview
              feature, you will need to provide a read-only API key for each exchange you want to monitor. This
              key is used solely to retrieve your account balance — nothing else. When generating API keys on your
              exchange, it is your responsibility to enable <strong>only read permissions</strong> and to explicitly
              disable trading, withdrawals, and any other operations. Most exchanges make this straightforward
              during the key creation process.
            </p>
            <p>
              <strong>How your keys are stored:</strong> API keys you provide are stored in encrypted form in our
              database. The encryption means that even personnel with direct access to the system infrastructure
              cannot read your keys in plain text.
            </p>
            <p>
              <strong>No asset movement, no risk:</strong> Because Micropincher never initiates trades, withdrawals,
              or any other operations that move funds, there is no mechanism by which the platform could cause
              financial harm to your exchange accounts — even in the unlikely event that a key were somehow
              compromised.
            </p>
            <p className="note">
              As a general best practice, always create dedicated read-only API keys for third-party tools and
              never reuse keys across services. Revoke and regenerate any key immediately if you suspect it has
              been exposed.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-simulator" className="info-section">
            <h2>
              Why use the trading simulator
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              Learning to trade funding rate arbitrage is a lot like learning to drive a car. In the beginning,
              all your attention goes to the basics — the dashboard, the gear shift, the pedals, the mirrors.
              You are so focused on operating the vehicle that you miss road signs, fail to notice what is
              happening around you, and feel permanently one step behind. After enough practice, all of that
              becomes automatic. You stop thinking about the mechanics and start thinking about the road, the
              traffic, and what is coming next.
            </p>
            <p>
              Arbitrage trading works the same way. In practice you are managing two positions simultaneously
              — and more often than not, you have more than one hedged pair open at the same time. You need to
              read numbers quickly, react to changing spreads, and make decisions under pressure. None of this
              is possible without prior experience. And learning it with real money will cost you — this is not
              a theoretical warning, it is personal experience.
            </p>
            <p>
              <strong>The simulator removes that cost.</strong> It is built to give you the highest possible
              fidelity to real trading conditions: fees are calculated the same way, prices reflect what you
              would actually get when buying or selling, orderbook depth limits apply, and volume constraints
              behave as they do on live exchanges. The goal is that nothing surprises you when you eventually
              switch to real money.
            </p>
            <p>
              After a few days or weeks in the simulator you will have developed an intuition that takes months
              to build any other way. You will understand how specific coins behave, how spreads move around
              funding time, how quickly conditions can change, and what a good exit looks like versus a rushed
              one. You will be ready — and that readiness has real financial value.
            </p>
            <p className="note">
              The trading simulator is currently available to our closed testing community. If you are interested
              in joining, contact us directly. We will do our best to accommodate you, though capacity is limited.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

          <section id="edu-eu-limitations" className="info-section">
            <h2>
              EU limitations
              <button className="back-to-nav" onClick={scrollToNavigation} title="Back to navigation">↑</button>
            </h2>
            <p>
              When trading on cryptocurrency exchanges from the EU region, certain limitations may apply. Some products
              or even entire markets (most commonly futures markets) may not be available to EU-based users. This is
              because exchanges have not yet fully met all regulatory requirements under EU regulations for these specific
              products, and therefore they cannot offer them to users located in the EU.
            </p>
            <p>
              Unfortunately, many exchanges do not provide clear information via their APIs about whether a particular
              product is accessible from a specific region. As a result, the Micropincher application attempts to estimate
              product availability indirectly by analyzing certain parameters that are typically available, such as
              maker/taker fees or funding rate values.
            </p>
            <p>
              This also explains why more trading opportunities may exist in the market than what a user currently sees
              in Micropincher. Some of those opportunities may involve products that are simply not tradable from the EU
              region.
            </p>
            <p>
              At the moment, Micropincher servers are located in the EU, which means the application is subject to the
              same regional limitations.
            </p>
            <p>
              We are actively working on a solution and believe that in the near future we will be able to provide access
              to all products, along with clear information about their availability across different trading regions.
            </p>
            <p className="note">
              Did not find what you were looking for? Ask us directly in our <a href="https://discordapp.com/channels/1484183121741090818/1484186803446480926" target="_blank" rel="noopener noreferrer">Discord Customer Support channel</a>.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Education;
